export default {
  methods: {
    // Utility Functions
    parseInteger(input) {
      return Number(this.formatInteger(input))
    },
    formatInteger(input) {
      if (typeof input === 'undefined' || input == null || isNaN(input) || isNaN(parseFloat(input))) {
        return 0;
      }
      return parseFloat(input).toFixed(0);
    },
    parsePercentage(input, round) {
      return Number(this.formatPercentage(input, round, false));
    },
    formatPercentage(input, round, injectCommasAndPercentageSymbol, precision = 0) {      
      if (typeof input === 'undefined' || input == null || isNaN(input) || isNaN(parseFloat(input))) {
        input = 0;
      }
      var newN = parseFloat(input).toFixed(precision || (round ? 1 : 2));
      if (injectCommasAndPercentageSymbol) {
        newN = newN.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '%';
      }
      return newN;
    },
    parseCurrency(input, round) {
      return Number(this.formatCurrency(input, round, false));
    },
    formatCurrency(input, round, injectCommasAndDollarSymbol) {
      if (typeof input === 'undefined' || input == null || isNaN(input) || isNaN(parseFloat(input))) {
        input = 0;
      }
      var newN = parseFloat(input).toFixed(round ? 0 : 2);
      if (injectCommasAndDollarSymbol) {
        newN = '$' + newN.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return newN;
    },
    halfRoundUp(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    // AG Grid Value Formatters
    numericFormatter(params) {
      return params.value?.toString(); // this ensures the number 0 gets displayed
    },
  }
}
